module.exports = function() {
	return new Worker(__webpack_public_path__ + "797aa449f90eb2b5503b.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./src/logic/csvParser.js
// module id = 482
// module chunks = 0